import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class FlashExpressSettingsProvider extends HttpRequest {
  getLastSetting () {
    this.setHeader(getAuthToken())
    return this.get('/flash-express-settings')
  }

  updateSetting (data) {
    this.setHeader(getAuthToken())
    return this.post('/flash-express-settings', data)
  }
}

export default FlashExpressSettingsProvider
